import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage, useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  },
  divider: {
    borderTop: `1px solid ${theme.palette.common.white}`,
    marginBottom: theme.spacing(0.5)
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    columnGap: theme.spacing(0.5),
    rowGap: theme.spacing(1)
  },
  noRole: {
    fontStyle: 'italic'
  }
}));

const ResourceRequestRoleTooltip = ({ role, roleCount }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <>
      <div className={classes.title}>
        <FormattedMessage id="resourceRequestReadonlyItem.requestedResources" />
      </div>
      <div className={classes.divider} />
      <div className={classes.gridContainer}>
        <FormattedMessage id="resourceRequestReadonlyItem.requestedRole" />
        <div>
          {role ? (
            role?.displayText
          ) : (
            <div className={classes.noRole}>
              <FormattedMessage id="resourceRequestReadonlyItem.noRole" />
            </div>
          )}
        </div>
        <div
          aria-label={formatMessage({
            id: 'resourceRequestReadonlyItem.requestedNumberofResources'
          })}
        >
          <span aria-hidden="true">
            <FormattedMessage id="resourceRequestReadonlyItem.numberOfResources" />
          </span>
        </div>
        <div>{roleCount}</div>
      </div>
    </>
  );
};

ResourceRequestRoleTooltip.propTypes = {
  role: PropTypes.object,
  roleCount: PropTypes.number.isRequired
};

export default ResourceRequestRoleTooltip;
